export default __webpack_public_path__ + "static/media/customer-care-illustration-concept_42694-26.4677ca3e.jpg";